import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { AuthenticatedUser } from '@/application/authentication/types';

const authenticationState = namespace('authentication');

@Component
export default class DefaultRedirect extends Vue {

  @authenticationState.State
  user!: AuthenticatedUser;

  mounted(): void {
    this.$router.push({ name: 'product-search/search' });
  }

}
